module.exports = __webpack_public_path__ + "static/services_bd.06c7c879.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pageheaders/services_bd.jpg
// module id = 606
// module chunks = 54901965233954